import { DatePicker } from 'baseui/datepicker';

export default DatePicker;
